export enum TypeDomainPractice {
  Tipo1 = 1,
  Tipo7 = 7,
  Tipo8 = 8,
  Tipo11 = 11,
  Tipo13 = 13,
}
